import React from 'react'
import {
  CFView,
  CFText,
  CFImage,
  CFLink,
  DefaultScreen,
  MobileScreen,
} from 'components'
import Header from './Header'
import OrderPickupButton from './OrderPickupButton'
import OrderDeliveryButton from './OrderDeliveryButton'
import { hero, heroText, mobileHero, mobileHeroText } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView
          h="100vh"
          maxHeight="750px"
          image={`url(${mobileHero}) bottom/ cover no-repeat`}
          column
          justifyTop
          alignCenter
          textCenter
          pt="10%"
        >
          <CFImage
            w="95%"
            src={mobileHeroText}
            alt="Maguro Sushi hero text"
            zIndex={98}
          />
          <CFView pulsate mt="10px">
            <OrderPickupButton />
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <Header />
        <CFView
          h="95vh"
          maxHeight="650px"
          w="100%"
          image={`url(${hero}) 45% 0 / cover repeat`}
          style={{ backgroundAttachment: 'fixed', backgroundSize: '1440px' }}
          zIndex={90}
          column
          justifyCenter
          alignEnd
        >
          <CFView column center mr="5%">
            <CFImage
              w="45vw"
              minWidth="500px"
              maxWidth="580px"
              src={heroText}
              alt="Maguro Sushi hero text"
              zIndex={98}
            />
            <CFView pulsate mt="25px">
              <OrderPickupButton />
            </CFView>
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
